import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Check from '@material-ui/icons/Check';

import styles from './Option.css';


class Option extends Component {
  static propTypes = {
    option: PropTypes.object.isRequired,
    children: PropTypes.node,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus: PropTypes.func,
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    children: null,
    isFocused: undefined,
    isSelected: undefined,
    onFocus: () => undefined,
    onSelect: () => undefined,
  };

  onMouseDown = (event) => {
    const { option, onSelect } = this.props;

    event.preventDefault();
    event.stopPropagation();
    onSelect(option, event);
  };

  onMouseEnter = (event) => {
    const { option, onFocus } = this.props;

    onFocus(option, event);
  };

  onMouseMove = (event) => {
    const { isFocused, option, onFocus } = this.props;

    if (isFocused) {
      return;
    }

    onFocus(option, event);
  };

  render() {
    const {
      isSelected,
      option,
      children,
    } = this.props;

    const {
      font,
      title,
      value,
    } = option || {};

    const classes = (isSelected && font) ? styles.selectedFont : styles.option;

    return (
      <div
        className={classes}
        id={`fontOption-${value}`}
        title={title}
        onMouseDown={this.onMouseDown}
        onMouseEnter={this.onMouseEnter}
        onMouseMove={this.onMouseMove}
      >
        {isSelected && <Check />}
        {children}
      </div>
    );
  }
}

export default Option;
